import 'axios';

const flatToTree = ({ list , children , level  })=>{
    if (!list) {
        return [];
    }
    const tree = [];
    children.forEach((item)=>{
        if (item.level === level) {
            const children = flatToTree({
                list: list,
                children: list.filter((childrenItem)=>{
                    return childrenItem.parentId === item.id;
                }) || [],
                level: item.level + 1
            });
            tree.push({
                ...item,
                ...{
                    children
                }
            });
        }
    });
    return tree;
};
const arrayUnique = (array)=>[
        ...new Set(array)
    ];
const isServerSide = ()=>typeof window === 'undefined';
const isClientSide = ()=>typeof window !== 'undefined';
const roundTo2Decimals = (num)=>{
    return +(Math.round(num + 'e+2') + 'e-2');
};
const isNumber = (v)=>v !== undefined && v !== null && !Number.isNaN(v);

export { arrayUnique, flatToTree, isClientSide, isNumber, isServerSide, roundTo2Decimals };
